function slotName(player) {
  return player?.name || '—';
}

export function formatLineupText(forwards, defensemen, lineupGoalies, { title = 'My Lineup' } = {}) {
  const lines = [title, ''];

  forwards.forEach((line, idx) => {
    const label = idx === 4 ? 'Extra FW' : `L${idx + 1}`;
    lines.push(
      `${label}: ${slotName(line.LW)} - ${slotName(line.C)} - ${slotName(line.RW)}`
    );
  });

  lines.push('');
  defensemen.forEach((pair, idx) => {
    lines.push(`D${idx + 1}: ${slotName(pair.D1)} - ${slotName(pair.D2)}`);
  });

  lines.push('');
  lineupGoalies.forEach((goalie, idx) => {
    lines.push(`G${idx + 1}: ${slotName(goalie)}`);
  });

  return lines.join('\n');
}

export async function copyTextToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch {
      return false;
    }
  }
}

export function downloadTextFile(text, filename = 'tugg-lineup.txt') {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Draw a simple lineup card to PNG without external deps. */
export function downloadLineupImage(forwards, defensemen, lineupGoalies, {
  title = 'Tugg Lineup',
  filename = 'tugg-lineup.png',
} = {}) {
  const rows = [];
  forwards.forEach((line, idx) => {
    rows.push({
      label: idx === 4 ? 'XFW' : `L${idx + 1}`,
      text: `${slotName(line.LW)}  ·  ${slotName(line.C)}  ·  ${slotName(line.RW)}`,
    });
  });
  rows.push({ label: '', text: '' });
  defensemen.forEach((pair, idx) => {
    rows.push({
      label: `D${idx + 1}`,
      text: `${slotName(pair.D1)}  ·  ${slotName(pair.D2)}`,
    });
  });
  rows.push({ label: '', text: '' });
  lineupGoalies.forEach((goalie, idx) => {
    rows.push({ label: `G${idx + 1}`, text: slotName(goalie) });
  });

  const width = 720;
  const rowH = 36;
  const pad = 32;
  const height = pad * 2 + 56 + rows.length * rowH;

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#0f172a';
  ctx.fillRect(0, 0, width, height);

  ctx.fillStyle = '#f8fafc';
  ctx.font = 'bold 28px system-ui, sans-serif';
  ctx.fillText(title, pad, pad + 28);

  ctx.strokeStyle = '#334155';
  ctx.beginPath();
  ctx.moveTo(pad, pad + 44);
  ctx.lineTo(width - pad, pad + 44);
  ctx.stroke();

  let y = pad + 72;
  rows.forEach((row) => {
    if (!row.label && !row.text) {
      y += rowH * 0.4;
      return;
    }
    ctx.fillStyle = '#94a3b8';
    ctx.font = 'bold 14px system-ui, sans-serif';
    ctx.fillText(row.label, pad, y);
    ctx.fillStyle = '#e2e8f0';
    ctx.font = '16px system-ui, sans-serif';
    ctx.fillText(row.text, pad + 56, y);
    y += rowH;
  });

  const url = canvas.toDataURL('image/png');
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
